import _objectSpread from "/codebuild/output/src4035996522/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/codebuild/output/src4035996522/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

var Input = function Input(element, callback, options) {
  _classCallCheck(this, Input);

  this.element = element;
  this.callback = callback;
  this.options = _objectSpread({
    enable: true
  }, options);
};

export { Input as default };